import Repository from "./Repository";

import { httpClient } from "@/shared/services";

const resource = "/login";

const login = payload => {
  return httpClient.post(resource, payload).then(res => res.data);
};

export { login };

export default {
  // login(payload) {
  //   return Repository.post(resource, payload);
  // },

  /**
   * Request password reset
   *
   * @param email Email address
   */
  requestPasswordReset(email) {
    return Repository.post("/password/email", {
      email,
      platform: "TABLET"
    });
  },

  /**
   * Password reset
   *
   * @param email Email address
   * @param password New password
   * @param token Token
   */
  passwordReset({ email, password, token }) {
    return Repository.post("/password/reset", {
      email,
      password,
      token
    });
  }
};
